import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Modal = styled(AntModal)`

.ant-modal-title {
    text-align: center;
    color: #90348a;
}

.ant-modal-content {
    text-align: center;
}

.ant-modal-footer {
    text-align: center;

    .ant-btn-default {
        display: none !important;
    }
}
`;

const SpinAlert = ({
    open,
    title,
    description,
    onOk,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            width={300}
            title={title}
            open={open}
            onOk={onOk}
            okText={t('common.ok')}
        >
            {description}
        </Modal>
    );
}

export default SpinAlert;